import * as React from 'react';
import * as ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { Route } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '@built/design-system/index.css';
import './index.scss';

import App from './containers/App';
import { StoreState } from './types';
import reducers from './reducers';
import { initialize } from './actions';
import history from './history';
import { clearInvalidCookies } from './utils';
import { injectSnowplow } from './actions';

// immediately clear up auth related cookies that don't
// belong
clearInvalidCookies();

// Call it once in your app. At the root of your app is the best place
toast.configure();

// Inject snowplow script for local environments
if (process.env.REACT_APP_SNOWPLOW_ENABLED === 'true') {
  injectSnowplow();
}

const store = createStore<StoreState>(
  // TODO: remove the any cast when redux typings can handle strict TS flags
  // tslint:disable-next-line:no-any
  combineReducers({ ...reducers } as any),
  applyMiddleware(thunk)
);

store.dispatch(initialize());

// The App component must be rendered using a Route to ensure that it
// re-renders properly when the browser location is updated via the history
// API (see
// https://github.com/ReactTraining/react-router/blob/master/packages/
//   react-router/docs/guides/blocked-updates.md#dealing-with-update-blocking)

// Router is used rather than BrowserRouter to allow the use of a custom
// history object (see
// https://github.com/ReactTraining/react-router/issues/4059#issuecomment-302491292).

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route component={App} />
    </Router>
  </Provider>,
  document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx